import { render, staticRenderFns } from "./AccettazioneSsnListaPage.vue?vue&type=template&id=02d587f0&scoped=true"
import script from "./AccettazioneSsnListaPage.vue?vue&type=script&lang=js"
export * from "./AccettazioneSsnListaPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02d587f0",
  null
  
)

export default component.exports